import Vue from 'vue';
const state = {
    customer: {},
    customers: [],
}
const actions = {
    showCustomers: (context) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/customers`).then(response => {
                context.commit('SHOW_CUSTOMERS', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },

    showByCard: (context, id) => {
        // Só faz a requisição se o id for diferente do customer atual
        if (context.state.customer && context.state.customer.id === id) {
            return Promise.resolve({ data: { data: context.state.customer } });
        }
        context.commit('SHOW_CUSTOMER', {})
        return new Promise((resolve, reject) => {
            axios.get(`/api/customers/card/${id}`).then(response => {
                context.commit('SHOW_CUSTOMER', response.data.data)
                resolve(response)
            }).catch(error => {
                context.commit('SHOW_CUSTOMER', {})
                reject(error)
            })
        })
    },
    showCustomer: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/customers/${id}`).then(response => {
                context.commit('SHOW_CUSTOMER', response.data.data)
                resolve(response)
            }).catch(error => {
                context.commit('SHOW_CUSTOMER', {})
                reject(error)
            })
        })
    },
    storeCustomer: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(`/api/customers`, payload).then(response => {
                context.commit('STORE_CUSTOMER', response.data)
                context.dispatch('showCustomers')
                Vue.$toast.info("Cliente cadastrado");
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    updateCustomer: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(`/api/customers/${payload.id}`, payload).then(response => {
                context.dispatch('showCustomer', payload.id)
                Vue.$toast.info("Cliente atualizado");
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    destroyCustomer: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/customers/${id}`).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    showByCPF: (context, cpf) => {
        context.commit('SHOW_CUSTOMER', {})
        return new Promise((resolve, reject) => {
            axios.get(`/api/customers/cpf/${cpf}`).then(response => {
                context.commit('SHOW_CUSTOMER', response.data)
                resolve(response)
            }).catch(error => {
                context.commit('SHOW_CUSTOMER', {})
                reject(error)
            })
        })
    },
    showByPhone: (context, phone) => {
        context.commit('SHOW_CUSTOMER', {})
        return new Promise((resolve, reject) => {
            axios.get(`/api/customers/phone/${phone}`).then(response => {
                context.commit('SHOW_CUSTOMER', response.data)
                resolve(response)
            }).catch(error => {
                context.commit('SHOW_CUSTOMER', {})
                reject(error)
            })
        })
    }
}
const mutations = {

    SHOW_CUSTOMER: (state, payload) => {
        state.customer = payload
    },
    SHOW_CUSTOMERS: (state, payload) => {
        state.customers = payload
    },
    STORE_CUSTOMER: (state, payload) => {
        state.customer = payload
    }
}
const getters = {
    customer: state => {
        return state.customer
    },
    customers: state => {
        return state.customers
    }
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
